'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _messages = require('common/messages');

var _product = require('./product.html');

var _product2 = _interopRequireDefault(_product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _product2.default,
  bindings: {
    product: '<',
    productLabel: '<',
    animalTypes: '<',
    categories: '<',
    frequencies: '<',
    administrationUnits: '<',
    weightUnits: '<'
  },
  controller: function () {
    function ProductComponent($mdDialog, $scope, $state, ameLightbox, AuthService, ArrayService, IngredientService, LoadingService, ProductService, ToastService, Upload) {
      'ngInject';

      _classCallCheck(this, ProductComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        $state: $state,
        ameLightbox: ameLightbox,
        ArrayService: ArrayService,
        AuthService: AuthService,
        IngredientService: IngredientService,
        LoadingService: LoadingService,
        ProductService: ProductService,
        ToastService: ToastService,
        Upload: Upload
      });
    }

    _createClass(ProductComponent, [{
      key: '$onInit',
      value: function $onInit() {
        // Make sure we're on the right page for the product type
        if (this.product.IsTreat) {
          this.$state.go('treatProductEdit', { id: this.product.ProductId }, { reload: true });
          return;
        }

        this.product.tblDoses = this.product.tblDoses || [];
        this.product.tblUsages = this.product.tblUsages || [];
        this.selectedLoadingAdministrations = [];
        this.selectedMaintenanceAdministrations = [];
        this.product.tblUsages = this.ProductService.transformUsages(this.product.ProductId, this.product.DateIntroduced, this.product.tblUsages);

        this.selectedIngredients = [];
        this.labelChanged = false;
        this.duplicateAdministration = false;
        this.product.tblProduct_UserIngredient = this.product.tblProduct_UserIngredient || [];

        this.maxDate = new Date();

        this.copyAreas = ['Product Information', 'Administrations', 'Product Ingredients']; // CG 11/15/2023 removed Usage Data from this list. We should not copy Usage between products.
      }
    }, {
      key: 'onLoadingDoseRequiredChanged',
      value: function onLoadingDoseRequiredChanged($event) {
        if ($event && !$event.loadingDoseRequired) {
          this.product.tblDoses = this.product.tblDoses.filter(function (d) {
            return d.Isloading === false;
          });
        }
      }
    }, {
      key: 'signOff',
      value: function signOff() {
        var _this = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          productId: this.product.ProductId,
          units: this.unitPerContainer,
          chosenUnits: this.chosenUnits,
          isTreat: false,
          onSignedOff: function onSignedOff($event) {
            return _this.onSignedOff($event);
          }
        });

        if (this.product.tblProduct_UserIngredient.length === 0) {
          this.ToastService.showWarning('Must specify Ingredients before signing off');
        } else if (this.product.tblDoses.length === 0) {
          this.ToastService.showWarning('Must specify Directions for Use before signing off');
        } else {
          this.$mdDialog.show({
            clickOutsideToClose: true,
            fullscreen: true,
            scope: scope,
            template: '\n            <md-dialog class="flex-50">\n              <md-dialog-content>\n                <dialog-close/>\n                <sign-off product-id="productId"\n                  units="units" chosen-units="chosenUnits"\n                  is-treat="false"\n                  on-signed-off="onSignedOff($event)">\n                </sign-off>\n              </md-dialog-content>\n            </md-dialog>\n            '
          });
        }
      }
    }, {
      key: 'saveProduct',
      value: function saveProduct() {
        var _this2 = this;

        var promise = void 0;
        if (this.product.ProductId) {
          promise = this.ProductService.update(this.product);
        } else {
          promise = this.ProductService.create(this.product);
        }

        return promise.then(function (r) {
          _this2.product.ProductId = _this2.product.ProductId || r.data.Id;
        }).then(function () {
          return _this2.saveProductLabel();
        });
      }
    }, {
      key: 'onSignedOff',
      value: function onSignedOff(_ref) {
        var _this3 = this;

        var signature = _ref.signature;

        if (signature) {
          this.LoadingService.start();
          this.saveProduct().then(function () {
            return _this3.ProductService.signOff(_this3.product.ProductId, signature);
          }).then(function () {
            _this3.$mdDialog.hide();
            _this3.ToastService.showSuccess(_messages.PRODUCT_SIGNATURE_ADDED);
            _this3.$state.go('productEdit', { id: _this3.product.ProductId }, { reload: true });
          }).catch(function (error) {
            return _this3.ToastService.showError(error);
          }).finally(function () {
            return _this3.LoadingService.stop();
          });
        }
      }
    }, {
      key: 'showCopy',
      value: function showCopy() {
        var _this4 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          copyAreas: this.copyAreas,
          isTreat: false,
          onCopied: function onCopied($event) {
            return _this4.onCopied($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <product-copy copy-areas="copyAreas" is-treat="isTreat"\n                on-copied="onCopied($event)">\n              </product-copy>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onCopied',
      value: function onCopied($event) {
        var _this5 = this;

        var selectedCopyAreas = $event.copyAreas;

        this.ProductService.getProduct($event.product.ProductId).then(function (p) {
          var copyFromProduct = p.data;

          if (selectedCopyAreas && selectedCopyAreas.length) {
            _this5.product = _extends({}, _this5.ProductService.copyProduct(_this5.product, copyFromProduct, selectedCopyAreas));
          }

          _this5.ToastService.showSuccess(_messages.PRODUCT_COPIED);
          _this5.$mdDialog.hide();
        }).catch(function (error) {
          return _this5.ToastService.showError(error);
        });
      }
    }, {
      key: 'dateFirstSoldChanged',
      value: function dateFirstSoldChanged($event) {
        this.product.tblUsages = this.ProductService.transformUsages(this.product.ProductId, $event.dateFirstSold, this.product.tblUsages);
      }
    }, {
      key: 'saveChanges',
      value: function saveChanges() {
        var _this6 = this;

        var saveMessage = this.product.ProductId ? _messages.PRODUCT_EDITED : _messages.PRODUCT_ADDED;
        this.LoadingService.start();
        this.saveProduct().then(function () {
          _this6.ToastService.showSuccess(saveMessage);
          _this6.$state.go('productEdit', { id: _this6.product.ProductId }, { reload: true });
        }).catch(function (error) {
          return _this6.ToastService.showError(error);
        }).finally(function () {
          return _this6.LoadingService.stop();
        });
      }
    }, {
      key: 'saveProductLabel',
      value: function saveProductLabel() {
        if (this.productLabel && this.productLabel instanceof File) {
          return this.ProductService.uploadLabel(this.product.ProductId, this.productLabel);
        }

        return Promise.resolve(true);
      }
    }, {
      key: 'setLabelImage',
      value: function setLabelImage(_ref2) {
        var productLabel = _ref2.productLabel;

        this.productLabel = productLabel;

        if (productLabel) {
          this.ToastService.showSuccess(_messages.PRODUCT_LABEL_CHANGED);
        }
      }
    }, {
      key: 'onAdministrationAdded',
      value: function onAdministrationAdded(_ref3) {
        var administration = _ref3.administration,
            shouldClose = _ref3.shouldClose;

        if (administration) {
          this.product.tblDoses = this.ArrayService.add(this.product.tblDoses, administration);

          this.ToastService.showSuccess(_messages.ADMINISTRATION_ADDED);
          if (shouldClose) {
            this.$mdDialog.hide();
          }
        }
      }
    }, {
      key: 'onAdministrationEdited',
      value: function onAdministrationEdited(_ref4) {
        var administration = _ref4.administration,
            index = _ref4.index;

        if (administration && index !== null) {
          this.product.tblDoses = this.ArrayService.update(this.product.tblDoses, administration, index);

          this.ToastService.showSuccess(_messages.ADMINISTRATION_EDITED);
          this.$mdDialog.hide();
          this.selectedLoadingAdministrations = [];
          this.selectedMaintenanceAdministrations = [];
        }
      }
    }, {
      key: 'maintenanceAdministrationAdd',
      value: function maintenanceAdministrationAdd() {
        var _this7 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          administration: undefined,
          administrations: _angular2.default.copy(this.product.tblDoses),
          units: this.unitPerContainer,
          animalTypes: this.animalTypes,
          frequencies: this.frequencies,
          unitsDisplay: this.unitsDisplay,
          administrationChanged: function administrationChanged($event) {
            return _this7.onAdministrationAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <maintenance-admin-form\n                administration="administration"\n                administrations="administrations"\n                units="units"\n                animal-types="animalTypes"\n                frequencies="frequencies"\n                units-display="unitsDisplay"\n                submit-title="Add Administration"\n                show-additional-button="true"\n                administration-changed="administrationChanged($event)">\n              </maintenance-admin-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'maintenanceAdministrationEdit',
      value: function maintenanceAdministrationEdit(administration) {
        var _this8 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          administration: _angular2.default.copy(administration),
          administrations: _angular2.default.copy(this.product.tblDoses),
          units: this.unitPerContainer,
          animalTypes: this.animalTypes,
          frequencies: this.frequencies,
          unitsDisplay: this.unitsDisplay,
          index: this.product.tblDoses.indexOf(administration),
          administrationChanged: function administrationChanged($event) {
            return _this8.onAdministrationEdited($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <maintenance-admin-form\n                administration="administration"\n                administrations="administrations"\n                units="units"\n                animal-types="animalTypes"\n                frequencies="frequencies"\n                units-display="unitsDisplay"\n                submit-title="Save Changes"\n                administration-changed="administrationChanged($event)"\n                index="index">\n              </maintenance-admin-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'maintenanceAdministrationDelete',
      value: function maintenanceAdministrationDelete(administrations) {
        var _this9 = this;

        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected maintenance administration(s) cannot be recovered!').ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          try {
            for (var i = administrations.length - 1; i >= 0; i -= 1) {
              _this9.product.tblDoses = _this9.ArrayService.remove(_this9.product.tblDoses, administrations[i]);
            }

            _this9.ToastService.showSuccess(_messages.ADMINISTRATION_DELETED);
            _this9.selectedMaintenanceAdministrations = [];
          } catch (e) {
            _this9.ToastService.showError();
          }
        });
      }
    }, {
      key: 'loadingAdministrationAdd',
      value: function loadingAdministrationAdd() {
        var _this10 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          administration: undefined,
          administrations: _angular2.default.copy(this.product.tblDoses),
          animalTypes: this.animalTypes,
          frequencies: this.frequencies,
          unitsDisplay: this.unitsDisplay,
          administrationChanged: function administrationChanged($event) {
            return _this10.onAdministrationAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <loading-admin-form\n                administration="administration"\n                administrations="administrations"\n                animal-types="animalTypes"\n                frequencies="frequencies"\n                units-display="unitsDisplay"\n                submit-title="Add Administration"\n                show-additional-button="true"\n                administration-changed="administrationChanged($event)">\n              </loading-admin-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'loadingAdministrationEdit',
      value: function loadingAdministrationEdit(administration) {
        var _this11 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          administration: _angular2.default.copy(administration),
          administrations: _angular2.default.copy(this.product.tblDoses),
          animalTypes: this.animalTypes,
          frequencies: this.frequencies,
          unitsDisplay: this.unitsDisplay,
          index: this.product.tblDoses.indexOf(administration),
          administrationChanged: function administrationChanged($event) {
            return _this11.onAdministrationEdited($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <loading-admin-form\n                administration="administration"\n                administrations="administrations"\n                animal-types="animalTypes"\n                frequencies="frequencies"\n                units-display="unitsDisplay"\n                submit-title="Save Changes"\n                index="index"\n                administration-changed="administrationChanged($event)">\n              </loading-admin-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'loadingAdministrationDelete',
      value: function loadingAdministrationDelete(administrations) {
        var _this12 = this;

        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected loading administration(s) cannot be recovered!').ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          try {
            for (var i = administrations.length - 1; i >= 0; i -= 1) {
              _this12.product.tblDoses = _this12.ArrayService.remove(_this12.product.tblDoses, administrations[i]);
            }

            _this12.ToastService.showSuccess(_messages.ADMINISTRATION_DELETED);
            _this12.selectedLoadingAdministrations = [];
          } catch (e) {
            _this12.ToastService.showError();
          }
        });
      }
    }, {
      key: 'onIngredientAdded',
      value: function onIngredientAdded(_ref5) {
        var ingredient = _ref5.ingredient,
            shouldClose = _ref5.shouldClose;

        if (ingredient) {
          this.product.tblProduct_UserIngredient = this.ArrayService.add(this.product.tblProduct_UserIngredient, ingredient);
          this.ToastService.showSuccess(_messages.PRODUCT_INGREDIENT_ADDED);
          if (shouldClose) {
            this.$mdDialog.hide();
          }
        }
      }
    }, {
      key: 'onIngredientEdited',
      value: function onIngredientEdited(_ref6) {
        var ingredient = _ref6.ingredient,
            index = _ref6.index;

        if (ingredient && index !== null) {
          this.product.tblProduct_UserIngredient = this.ArrayService.update(this.product.tblProduct_UserIngredient, ingredient, index);
          this.ToastService.showSuccess(_messages.PRODUCT_INGREDIENT_EDITED);
          this.$mdDialog.hide();
          this.selectedIngredients = [];
        }
      }
    }, {
      key: 'ingredientAdd',
      value: function ingredientAdd() {
        var _this13 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          companyId: this.product.MemberId,
          ingredients: _angular2.default.copy(this.product.tblProduct_UserIngredient),
          unitsDisplay: this.unitsDisplay,
          weightUnits: this.weightUnits,
          ingredientChanged: function ingredientChanged($event) {
            return _this13.onIngredientAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <product-ingredient-form\n                ingredients="ingredients"\n                weight-units="weightUnits"\n                units-display="unitsDisplay"\n                submit-title="Add Ingredient"\n                show-additional-button="true"\n                company-id="companyId"\n                ingredient-changed="ingredientChanged($event)">\n              </product-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'ingredientEdit',
      value: function ingredientEdit(ingredient) {
        var _this14 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          ingredient: _angular2.default.copy(ingredient),
          ingredients: _angular2.default.copy(this.product.tblProduct_UserIngredient),
          companyId: this.product.MemberId,
          index: this.product.tblProduct_UserIngredient.indexOf(ingredient),
          unitsDisplay: this.unitsDisplay,
          weightUnits: this.weightUnits,
          ingredientChanged: function ingredientChanged($event) {
            return _this14.onIngredientEdited($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <product-ingredient-form\n                ingredient="ingredient"\n                ingredients="ingredients"\n                weight-units="weightUnits"\n                units-display="unitsDisplay"\n                submit-title="Save Changes"\n                company-id="companyId"\n                ingredient-changed="ingredientChanged($event)"\n                index="index">\n              </product-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'ingredientDelete',
      value: function ingredientDelete(ingredients) {
        var _this15 = this;

        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected ingredient(s) cannot be recovered!').ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          try {
            for (var i = ingredients.length - 1; i >= 0; i -= 1) {
              _this15.product.tblProduct_UserIngredient = _this15.ArrayService.remove(_this15.product.tblProduct_UserIngredient, ingredients[i]);
            }

            _this15.ToastService.showSuccess(_messages.PRODUCT_INGREDIENT_DELETED);
            _this15.selectedIngredients = [];
          } catch (e) {
            _this15.ToastService.showError();
          }
        });
      }
    }, {
      key: 'unitsDisplay',
      get: function get() {
        return this.ProductService.getUnitsDisplay(this.product);
      }
    }, {
      key: 'unitPerContainer',
      get: function get() {
        return this.product.UnitPerContainer;
      }
    }, {
      key: 'chosenUnits',
      get: function get() {
        return this.product.ProductForm;
      }
    }, {
      key: 'labelValid',
      get: function get() {
        return this.productLabel || this.product.FileLabelName;
      }
    }, {
      key: 'shouldBeLocked',
      get: function get() {
        if (this.AuthService.isSysAdmin) {
          return false;
        }

        return this.product.Signature && this.product.Signature.length > 0;
      }
    }]);

    return ProductComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/product.component.js